/**
 * Product segments captured against an outlet, and the unit each is measured in.
 *
 * Shared by the Outlets screen and by outlet capture during a visit so the two
 * forms cannot drift apart - the OUTLET (EDIT) sheet expects every segment to be
 * shown, with the user filling in only the quantities.
 */
export const SEGMENT_UOM = {
  Milk: 'Litre',
  Curd: 'Kg',
  'Set Curd': 'Kg',
  Lassi: 'Litre',
  Paneer: 'Kg',
  Ghee: 'Kg',
};

export const SEGMENTS = Object.keys(SEGMENT_UOM);

export const ACTIVATION_TYPES = ['New', 'Existing', 'Reactivated'];

/**
 * Turn the form's {segment: "12"} map into the API's list.
 *
 * Every segment goes up, zeros included. Dropping them made a declared nought
 * indistinguishable from a segment nobody was asked about, which the volume
 * report then had no way to tell apart.
 */
export const toSegmentVolumes = (volumes) =>
  SEGMENTS.map((segment) => ({
    segment,
    volume: Number(volumes?.[segment]) || 0,
    uom: SEGMENT_UOM[segment] || '',
  }));

export default SEGMENTS;
